import React, { memo, useEffect } from 'react';
import {
  selectErroriCarrelloByTicket,
  selectPuntataSingolaMultiplaByTicketType,
  selectTipo,
} from '../carrelloSelectors';
import {
  showErroriOnImportoUpdated,
  updatePuntataSingolaMultipla,
} from 'features/carrello/carrelloEditQuotaInput/actions';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { CarrelloActionScommetti } from 'features/carrello/carrelloActionScommetti';
import { CarrelloInputImporto } from 'features/carrello/carrelloInputImporto';
import { TicketErrore } from 'features/carrello/types';
import classNames from 'classnames';
import styles from './CarrelloEditQuotaInput.module.scss';
import { useInternalSession } from 'hooks/useInternalSession';
import { useIsDivisible } from 'features/carrello/carrelloEditQuotaInput/hooks';
import { useIsSaldoGiocabile } from 'features/carrello/hooks';
import { isSnaiSite } from 'utility/constant';
import { isTruthy } from 'utility/functions';

export type CarrelloEditQuotaInputProps = {
  hasBtn?: boolean;
  defaultValue: number;
  hasPadding?: boolean;
  hasAction?: boolean;
  hasOnlyHorizontalPadding?: boolean;
};
export const CarrelloEditQuotaInput = memo(function CarrelloEditQuotaInput({
  hasBtn,
  hasAction,
  hasPadding,
  hasOnlyHorizontalPadding,
}: CarrelloEditQuotaInputProps) {
  const dispatch = useAppDispatch();
  const type = useTypedSelector((state) => state.carrello.tipo);

  const puntataInputValue = useTypedSelector((state) => selectPuntataSingolaMultiplaByTicketType(state, type));

  const carrelloType = useTypedSelector(selectTipo);
  const erroriCarrello = useTypedSelector((state) => selectErroriCarrelloByTicket(state, carrelloType));
  const isSaldoGiocabile = useIsSaldoGiocabile();
  const { isAuthenticated } = useInternalSession();

  const isDivisible = useIsDivisible(+puntataInputValue);

  useEffect(() => {
    if (isDivisible && puntataInputValue) {
      dispatch(updatePuntataSingolaMultipla(puntataInputValue));
    } else {
      dispatch(showErroriOnImportoUpdated('erroriCarrello', TicketErrore.IncrementoImportoSingolaMultiplaNonCorretto));
    }
    if (!isSaldoGiocabile && isAuthenticated) {
      dispatch(showErroriOnImportoUpdated('erroriCarrello', TicketErrore.ImportoNonSuperioreCredito));
    }
  }, [dispatch, isAuthenticated, isDivisible, isSaldoGiocabile, puntataInputValue]);

  return (
    <div
      className={classNames(styles.container, {
        [styles.hasPadding]: hasPadding,
        [styles.hasOnlyHorizontalPadding]: hasOnlyHorizontalPadding,
        [styles.margin]: isSnaiSite,
      })}
    >
      <CarrelloInputImporto
        hasBtn={hasBtn}
        puntata={puntataInputValue}
        hasError={isTruthy(erroriCarrello?.length)}
        setPuntataInputValue={(value) => {
          const newValue = typeof value === 'string' ? value : undefined;
          dispatch(updatePuntataSingolaMultipla(newValue!));
        }}
      />
      {hasAction && <CarrelloActionScommetti btnClassName={classNames(styles.button, { [styles.snai]: isSnaiSite })} />}
    </div>
  );
});
